import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { processMessage } from "../../../utils";
import { Chips } from "../../Chips/Chips";
import "./BenchmarkBaseData.scss";

export const BenchmarkBaseData = ({ control, editDisabled, tags, setTags }) => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="benchmark-base-data">
      <div className="flex-row">
        <div>
          <h2>{t("benchmark.baseData")}</h2>
        </div>
        <div className="text-right flex-auto">
          <IconButton onClick={() => setCollapsed(!collapsed)} size="small" className="collapse-trigger">
            {!!collapsed && <ExpandMoreIcon />}
            {!collapsed && <ExpandLessIcon />}
          </IconButton>
        </div>
      </div>
      <div className={"collapsible " + (collapsed ? "collapsed" : "")}>
        <div className="collapsible-inner flex-row">
          <div className="name-col">
            <Controller
              control={control}
              name="name"
              rules={{ required: true }}
              render={({ field, formState, fieldState }) => (
                <>
                  <TextField
                    error={fieldState.invalid}
                    fullWidth
                    label={t("benchmark.name") + " *"}
                    {...field}
                    disabled={editDisabled}
                    inputProps={{ maxLength: 255 }}
                  />
                  {formState.isSubmitted && fieldState.invalid && (
                    <FormHelperText error>
                      {fieldState.error.type === "required" &&
                        processMessage(t("validation.fieldRequired"), [t("benchmark.name")])}
                    </FormHelperText>
                  )}
                </>
              )}
            />
          </div>
          <div className="description-col">
            <Controller
              control={control}
              name="description"
              render={({ field }) => (
                <TextField
                  fullWidth
                  label={t("benchmark.description")}
                  {...field}
                  disabled={editDisabled}
                  inputProps={{ maxLength: 255 }}
                />
              )}
            />
          </div>
          <div className="tags-col">
            <FormControl fullWidth>
              <InputLabel shrink>{t("benchmark.tags")}</InputLabel>
              <Chips chips={tags || []} readOnly={editDisabled} onChange={setTags} changeOnBlur />
            </FormControl>
          </div>
        </div>
      </div>
    </div>
  );
};
